import React, { useState, useContext } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FeedContext } from '../../../utils/context/feedContext';
import { Formik } from 'formik';
import * as Yup from 'yup';

// Report form schema
const ReportSchema = Yup.object().shape({
    reason: Yup.string().required('Reason is required'),
    details: Yup.string().required('Details are required')
});

const ReportPostModal = ({ postId, showModal, handleClose }) => {
    const { handleReportPost, posts } = useContext(FeedContext);
    const post = posts.find(p => p?.feed?.action_id === postId);
    return (
        <Modal show={showModal} onHide={handleClose} size="md" centered>
            <Modal.Header closeButton>Report</Modal.Header>

            <Formik
                initialValues={{ reason: '', details: '' }}
                validationSchema={ReportSchema}
                onSubmit={async (values, { setSubmitting }) => {
                    await handleReportPost(postId, values.reason, values.details);
                    setSubmitting(false);
                    handleClose();
                }}
            >
                {({ handleSubmit, handleChange, values, errors, touched }) => (

                    <form onSubmit={handleSubmit}>
                        <Modal.Body>
                            {/* Reason select field */}
                            <Form.Group controlId="reason">
                                <Form.Label>Reason</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="reason"
                                    onChange={handleChange}
                                    value={values.reason}
                                    isInvalid={errors.reason && touched.reason}
                                >
                                    <option value="">Select a reason</option>
                                    <option value="spam">Spam</option>
                                    <option value="abuse">Abuse</option>
                                    <option value="inappropriate">Inappropriate Content</option>
                                    <option value="licensed">Licensed Material</option>
                                    <option value="other">Other</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {errors.reason}
                                </Form.Control.Feedback>
                            </Form.Group>
                            {/* Details textarea field */}
                            <Form.Group controlId="details" className="mt-3">
                                <Form.Label>Details</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="details"
                                    onChange={handleChange}
                                    value={values.details}
                                    isInvalid={errors.details && touched.details}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.details}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-evenly',
                                width: "100%"
                            }}>
                                <Button variant="danger" onClick={handleClose}>Cancel</Button>
                                <Button variant="primary" type="submit">Submit</Button>
                            </div>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>


        </Modal>
    )
}

export default ReportPostModal;